import React from 'react';
import styled from 'styled-components';
import { CertifiedSite } from '../../types';
import { useSite } from '../../contexts/SiteContext';
import { useNavigate } from 'react-router-dom';

interface CertifiedSiteListProps {
  sites: CertifiedSite[];
  showHeader?: boolean;
  columns?: number;
}

const CertifiedSection = styled.div`
  background-color: white;
  border: 1px solid #eaeaea;
  border-radius: 0.5rem;
  overflow: hidden;
`;

const CertifiedHeader = styled.div`
  background-color: #2563eb;
  color: white;
  padding: 0.75rem 1rem;
  font-weight: 500;
`;

interface CertifiedGridProps {
  columns: number;
}

const CertifiedGrid = styled.div<CertifiedGridProps>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  padding: 1rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    padding: 0.2rem 0.1rem;
    gap: 0.15rem;
  }
`;

const CertifiedItem = styled.a`
  display: flex;
  border: 1px solid #eaeaea;
  /* border-radius: 0.5rem; */
  overflow: hidden;
  transition: all 0.2s;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
  
  img {
    width: 100%;
    /* height: 60px; */
    object-fit: cover;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
      /* height: 70px; */
      object-fit: contain;
    }
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 0 0.25rem;
    border-width: 1px;
  }
`;

const CertifiedContent = styled.div`
  padding: 0.75rem;
  background-color: #f9fafb;
  border-top: 1px solid #eaeaea;
`;

const CertifiedName = styled.h3`
  font-weight: 500;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
`;

const CertifiedDesc = styled.p`
  color: #6b7280;
  font-size: 0.75rem;
`;

const CertifiedTag = styled.span`
  display: inline-block;
  background-color: #ef4444;
  color: white;
  font-size: 0.625rem;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  margin-right: 0.25rem;
`;
const CertifiedSiteList: React.FC<CertifiedSiteListProps> = ({ 
  sites, 
  showHeader = true,
  columns = 4
}) => {
  const { siteConfig } = useSite();
  const navigate = useNavigate();
  
  const handleSiteClick = (e: React.MouseEvent, url: string) => {
    e.preventDefault();
    
    // 외부 URL인 경우 새 창에서 열기
    if (url.startsWith('http')) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      // 내부 경로인 경우 React Router로 이동
      navigate(url);
    }
  };

  return (
    <CertifiedSection>
      {showHeader && (
        <CertifiedHeader>
          {siteConfig.siteName} 공식 보증업체
        </CertifiedHeader>
      )}
      <CertifiedGrid columns={columns}>
        {sites.map(site => (
          <CertifiedItem 
            key={site.id} 
            as="div" 
            onClick={(e) => handleSiteClick(e, site.url)}
            style={{ cursor: 'pointer' }}
          >
            <img src={site.imageUrl} alt={site.name} />
            {/* <CertifiedContent>
              <CertifiedName>
                {site.tags.map((tag, i) => (
                  <CertifiedTag key={i}>{tag}</CertifiedTag>
                ))}
                {site.name}
              </CertifiedName>
              <CertifiedDesc>{site.description}</CertifiedDesc>
            </CertifiedContent> */}
          </CertifiedItem>
        ))}
      </CertifiedGrid>
    </CertifiedSection>
  );
};

export default CertifiedSiteList; 